import React from 'react';
import { Box, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';


const useStyles = makeStyles((theme) => ({
    section: {
        height: '100vh',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',

    },

    container: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '10em',
        paddingLeft: '10em'
    },

    centeredContainer: {
        display: 'flex',
        flexDirection: 'column',
        flexBasis: '',
        alignItems: 'center',
        paddingTop: '30em'
    },

    title: {

    },

    items: {
    },

    halfSize: {
        maxWidth: '50%',
    },
}));

const ProductItemView = ({ title, items, image, centered }) => {

    const classes = useStyles();
    const theme = useTheme();

    const matchesXS = useMediaQuery(theme.breakpoints.up('xs'));
    const matchesSM = useMediaQuery(theme.breakpoints.up('sm'));
    const matchesMD = useMediaQuery(theme.breakpoints.up('md'));
    const matchesLG = useMediaQuery(theme.breakpoints.up('lg'));
    const matchesXL = useMediaQuery(theme.breakpoints.up('xl'));

    const titleVariant = matchesXL ? 'h2' : matchesLG ? 'h3' : matchesMD ? 'h3' : matchesSM ? 'h4' : matchesXS ? 'h5' : 'h6';
    const textVariant = matchesXL ? 'h4' : matchesLG ? 'h5' : matchesMD ? 'h6' : matchesSM ? 'h6' : matchesXS ? 'body1' : 'body1';


    return (
        <div className={classes.section} style={{ backgroundImage: `url(${image})` }}>

            <div className={centered ? classes.centeredContainer : classes.container} >
                <div >
                    <Typography variant={titleVariant} align="center">
                        <Box fontWeight={900} lineHeight={2} letterSpacing={2} color={theme.palette.arenco.darkBlue} align="left">
                            {title}
                        </Box>
                    </Typography>
                </div>

                {
                    items?.map(item =>
                        <div className={!centered && classes.halfSize}>
                            <Typography variant={textVariant} align="center">
                                <Box fontWeight={500} lineHeight={1.5} color={theme.palette.arenco.darkBlue} align="left">
                                    - {item}
                                </Box>
                            </Typography>
                        </div>
                    )
                }

            </div>


        </div>
    );
};

export default ProductItemView;